import styled from "styled-components/macro";

import type { ThemeProps } from "models/styles/theme";

import { Select } from "components/SelectUI/Select";

import { CssFlex } from "styles/helpers/layout";

export const StyledContainer = styled(CssFlex)`
  padding: 2.5rem;
  background: ${(props: ThemeProps) => props.theme.palette.neutral.white};
  width: 40rem;
  max-width: 100%;
`;

export const StyledSelect = styled(Select)`
  ul {
    max-height: 10rem;
    overflow-y: scroll;
  }
`;

export const StyledEducationTitle = styled.span`
  color: ${(props: ThemeProps) => props.theme.palette.secondary.brand};
`;
